import { render, staticRenderFns } from "./QuranProgramSystemic.vue?vue&type=template&id=8fde9598&scoped=true&"
import script from "./QuranProgramSystemic.vue?vue&type=script&lang=js&"
export * from "./QuranProgramSystemic.vue?vue&type=script&lang=js&"
import style0 from "./QuranProgramSystemic.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuranProgramSystemic.vue?vue&type=style&index=1&id=8fde9598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fde9598",
  null
  
)

export default component.exports